import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const PaymentSuccessChart = ({ data = [] }) => {
  const chartData = Array.isArray(data) ? data : [];

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">Payment Success vs Failed</h5>
      </div>

      <div className="card-body">
        {chartData.length ? (
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend />
              <Bar dataKey="value" name="Payments">
                {chartData.map((entry, index) => (
                  <Cell
                    key={`payment-result-${index}`}
                    fill={entry.name.toLowerCase() === "failed" ? "#dc3545" : "#198754"}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center text-muted"
            style={{ height: 320 }}
          >
            No payment result data available
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessChart;
